












































































































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, reactive, SetupContext, toRefs } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import axios from 'axios';
import JSZip from 'jszip';
import moment from 'moment';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Image = {
  id: string,
  name: string,
  url: string,
};

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
  image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
	created_at: string,
	updated_at: string,

  concept_image_id: string,
  cpcard_image_id: string,

  project_name: string,

  cpcard_image: Image,
};

type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,    
	updated_at: string,

  concepts: Concept[],
}

type Props = {
  id: string;
};

export default defineComponent({
  name: "ArchiveDetail",
  components: {
    NavHeader,
    Footer
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/project.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" }
    ]
  },
  filters: {
    moment: function (date: string) {
      moment.locale('ja')
      return moment(date).format('YYYY/MM/DD')
    },
    shorten: function (id: string) {
      if (id === null ) return '';
      if (id.length > 7)
        return id.substring(0, 7).toUpperCase();
      else
        return id;
    }
  },
 
  setup(props: Props, context: SetupContext) {
    const state = reactive({
      project: { name: '' } as Project,
    });

    async function loadImage(data: Blob): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: Event) => {
          resolve(reader.result as string);
        };
        reader.readAsDataURL(data);
      });
    }

    async function load() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {  // OPTIONAL
          pid: '',
          cid: ''
        }
      };

      const response = await API.get('dev', '/projects/' + props.id, options);
      state.project = response.data;
      state.project.concepts = await Promise.all(response.data.concepts.map(async (cp: Concept) => {
        if (cp.cpcard_image_id) {
          options.queryStringParameters.pid = cp.project_id;
          options.queryStringParameters.cid = cp.id;

          const cpcard = await API.get('dev', '/images/cpcards/' + cp.cpcard_image_id, options);
          cp.cpcard_image = cpcard.data;

          const image = await axios.get(cpcard.data.url, { responseType: 'blob' });
          cp.cpcard_image.url = await loadImage(image.data);
        } else {
          cp.cpcard_image = { id: '', name: '', url: '/images/archive_img.png'};
        }
        return cp;
      }));

      console.log(state);
    }
    load();

    async function deleteProject() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.del('dev', '/projects/' + props.id, options).then(response => {
        console.log(response);
        context.root.$router.push('/project');
      }).catch(err => {
        console.log(err);
      });
    }

    async function archiveProject() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.put('dev', '/projects/archives/' + props.id, options).then(response => {
        console.log(response);
        alert("TODO: move to archive mode");
      }).catch(err => {
        console.log(err);
      });
    }

    async function copyProject() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.post('dev', '/projects/copy/' + props.id, options).then(response => {
        console.log(response);
        context.root.$router.push({ name: 'ProjectEditor', params: { id: response.data.id } });
      }).catch(err => {
        console.log(err);
      });
    }

    async function downloadConceptImages() {
      if (state.project.concepts.length === 0) return;

      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {  // OPTIONAL
          pid: '',
          cid: ''
        }
      };

      const zip = new JSZip().folder('images');
      Promise.all(state.project.concepts.map(async (cp: Concept) => {
        if (cp.cpcard_image && cp.cpcard_image.url.startsWith('data')) {
          zip.file(
            cp.cpcard_image.name, 
            (await axios.get(cp.cpcard_image.url, { responseType: 'blob' })).data);
        }
      })).then(() => {
        zip.generateAsync({ type: 'blob' }).then(content => {
          saveAs(content, 'images.zip')
        });
      });
    }

    return {
      state,

      deleteProject,
      archiveProject,
      copyProject,

      downloadConceptImages,
    };
  }

});
